import { getData } from '../../_helpers/getData';
import React, { useCallback, useEffect, useState } from "react";
import constant from "./../../_config/constant";
import { processMediaUrl } from "../../_helpers/utils";
import { list } from "postcss";

function ChatCard({ onSelectChannel, data, activeChannel, setViewList }) {
  console.log(data, "dattttttttttttttttttttt");
  if (data.channelId == null || data.property == null) return null;

  const [unreadCount, setUnreadCount] = useState(data.unreadMessage);
  let activeClassname = "";
  // let cardName = `${data.property.name}-${data.property.user}-${data.property.host}`;
  let cardName = `${data.property.name}`;

  if (activeChannel && activeChannel.channelId === data.channelId) {
    activeClassname = " active-chat";
  }

  return (
    <div
      onClick={() => {
        setUnreadCount(0);
        onSelectChannel({
          sid: data.sid,
          name: data.name,
          channelId: data.channelId,
          user: data.user,
          host: data.host,
          property: data.property,
        });
        setViewList(true);
      }}
      className={`tw-flex tw-justify-between top-space-chat tw-items-center tw-cursor-pointer  tw-overflow-x-hidden  tw-p-4 hover-background  tw-text-primary tw-space-x-2 tw-rounded  ${activeClassname}`}
    >
      <div className="tw-flex tw-items-center tw-justify-start tw-space-x-2">
        <span className="tw-relative  tw-flex-shrink-0">
          <img
            alt=""
            src={processMediaUrl(data.property.picture)}
            className="tw-h-11 tw-w-11 tw-rounded-full tw-object-cover"
          />
          {/* <span
            className="tw-block tw-absolute border border-white  tw-rounded"
            style={{
              right: "3px",
              bottom: "3px",
              backgroundColor: "#06d6a0",
              height: "8px",
              width: "8px",
            }}
          ></span> */}
          {Boolean(unreadCount) && (
            <div className="tw-h-4 tw-w-4 tw-grid tw-place-content-center tw-text-xs tw-text-white tw-rounded-full tw-bg-[#e6ebf5] tw-absolute tw-top-0 tw-right-0 ">
              {unreadCount}
            </div>
          )}
        </span>
        <div className="tw-overflow-hidden">
          <p className="tw-text-xs tw-font-medium tw-mb-1 tw-block tw-truncate">
            {cardName.length <= 35 && cardName}
            {cardName.length > 35 && cardName.slice(0, 35) + "..."}
          </p>

          <p className="tw-text-xs tw-font-light tw-mb-0">
            Host: {data.property.host}
          </p>
          <p className="tw-text-xs tw-font-light tw-mb-0">
            User: {data.property.user}
          </p>

          <p className="tw-text-xs tw-font-light tw-mb-0">
            {data.lastMessageText}
          </p>
          {data.property.reservationId && (
            <p className="tw-text-xs tw-font-light tw-mb-0">
              {data.property.reservationId}
            </p>
          )}
        </div>
      </div>
      <p className="tw-text-xs">
        {data.invited && <p className="tw-text-primary ">New</p>}
      </p>
    </div>
  );
}

function ChatList({
  onSelectChannel,
  activeChannel,
  client,
  viewList,
  setViewList,
  refreshChatlist,
  setRefreshChatlist,
  onChannelsLoaded,
  channelsForForceUpdate,
}) {
  const [channelUserStatuses, setChannelUserStatuses] = useState({});
  const [pagination, setPagination] = useState({
    list: null,
    hasNextPage: false,
    hasPrevPage: false,
  });
  const [paginatorStack, setPaginatorStack] = useState([]); // 🔥 New: Track previous pages
  const [channels, setChannels] = useState({
    list: [],
    filtered: [],
    search: "",
  });
  const [loadingState, setLoadingState] = useState({
    initial: true,
    updating: false,
    paginationLoading: false, // 🔥 New state for pagination loader
  });
  const [receivingMessages, setReceivingMessages] = useState(new Set());
  const [allChannelsLoaded, setAllChannelsLoaded] = useState(false);

  const user = getData();

  const loadPage = async (direction) => {
    if (!pagination.list) return;
    setLoadingState((prev) => ({ ...prev, paginationLoading: true }));

    try {
      let newPage;

      if (direction === "next") {
        const nextPage = await pagination.list.nextPage();
        setPaginatorStack((prev) => [...prev, pagination.list]);
        newPage = nextPage;
      } else if (direction === "prev" && paginatorStack.length) {
        const prevPaginator = paginatorStack[paginatorStack.length - 1];
        setPaginatorStack((prev) => prev.slice(0, -1));
        newPage = prevPaginator;
      }

      if (!newPage) return;

      const channelsData = await Promise.all(
        newPage.items.map(async (curr) => {
          try {
            const channel = await client.current.getConversationBySid(curr.sid);
            const messages = await channel.getMessages();
            const receivedMessages = messages.items.filter(
              (msg) => msg.author !== user.id
            );
            const lastMessage = receivedMessages.length
              ? receivedMessages[receivedMessages.length - 1]
              : null;

            const members = await channel.getParticipants();
            const users = {};

            for (const member of members) {
              const userId = member.identity;
              const userStatus = await client.current.getUser(userId);
              users[userId] = userStatus;

              if (userId !== user.id.toString()) {
                users["displayState"] = userStatus.online;
              }
            }

            let unreadMessages = 0;
            try {
              unreadMessages = (await curr.getUnreadMessagesCount()) || 0;
            } catch (e) {
              // Twilio 404s when no read horizon is set yet for this user — treat as zero.
              unreadMessages = 0;
            }

            return {
              sid: curr.sid,
              channelId: curr.uniqueName,
              name: curr.friendlyName,
              property: curr.attributes.property,
              unreadMessages,
              lastMessageText: lastMessage ? lastMessage.body : "",
              lastMessageDate: lastMessage ? lastMessage.dateCreated : null,
              users,
              invited: false,
            };
          } catch (error) {
            return {
              sid: curr.sid,
              channelId: curr.uniqueName,
              name: curr.friendlyName || "Unknown Channel",
              property: curr.attributes.property || {},
              unreadMessages: 0,
              lastMessageText: "",
              lastMessageDate: null,
              users: {},
              invited: false,
            };
          }
        })
      );

      const userChannels = channelsData.sort(
        (a, b) => new Date(b.lastMessageDate) - new Date(a.lastMessageDate)
      );

      setChannels({ list: userChannels, filtered: userChannels, search: "" });
      setPagination({
        list: newPage,
        hasNextPage: newPage.hasNextPage,
        hasPrevPage: paginatorStack.length > 0, // 🔥 Updated check
      });
    } catch (error) {
      console.error("Error loading page:", error);
    } finally {
      setLoadingState((prev) => ({ ...prev, paginationLoading: false })); // Stop loader
    }
  };

  const fetchUserChannels = useCallback(
    async (isInitial = false) => {
      try {
        if (isInitial) {
          setLoadingState({ initial: true, updating: false });
        } else {
          setLoadingState((prev) => ({ ...prev, updating: true }));
        }

        // Phase 4 migration: getPublicChannelDescriptors() has no equivalent in @twilio/conversations.
        // Replaced with getSubscribedConversations(). Known regression: admin chat list will only
        // show conversations where the admin user is a participant. In the current implementation,
        // that likely means the list will be empty until backend-supported admin enumeration or an
        // admin participant/backfill strategy is added.
        const list =
          client &&
          client.current &&
          (await client.current.getSubscribedConversations());

        let requiredChannelsIds = channelsForForceUpdate.filter((x) => {
          return !list.items.find((y) => y.sid == x)
        })

        setPaginatorStack([]);
        setPagination({
          list,
          hasNextPage: list.hasNextPage,
          hasPrevPage: false,
        });

        const getChannelData = async (sid, channelDescriptor) => {
          try {
            const channel = await client.current.getConversationBySid(sid);
            const messages = await channel.getMessages();
            const receivedMessages = messages.items.filter(
              (msg) => msg.author !== user.id
            );
            const lastMessage = receivedMessages.length
              ? receivedMessages[receivedMessages.length - 1]
              : null;

            const members = await channel.getParticipants();
            const users = {};

            for (const member of members) {
              const userId = member.identity;
              const userStatus = await client.current.getUser(userId);
              users[userId] = userStatus;

              if (userId !== user.id.toString()) {
                users["displayState"] = userStatus.online;
              }
            }
            let unreadCount = 0
            try {
              unreadCount = (await channel.getUnreadMessagesCount()) || 0
            } catch (e) {
              // Twilio 404s when no read horizon is set yet for this user — treat as zero.
              unreadCount = 0
            }
            return {
              sid: (channel && channel.sid) || sid,
              channelId: channelDescriptor ? channelDescriptor.uniqueName || channel.uniqueName : channel.uniqueName,
              name: channelDescriptor ?channelDescriptor.friendlyName || channel.friendlyName : channel.friendlyName,
              property: channelDescriptor ? channelDescriptor.attributes.property || channel.attributes.property: channel.attributes.property,
              unreadMessages: unreadCount,
              lastMessageText: lastMessage ? lastMessage.body : "",
              lastMessageDate: lastMessage ? lastMessage.dateCreated : null,
              users,
              invited: false,
            };
          } catch (error) {
            return {
              sid: sid,
              channelId: channelDescriptor ? channelDescriptor.uniqueName : "",
              name: channelDescriptor ? channelDescriptor.friendlyName || "Unknown Channel" :  "Unknown Channel",
              property: channelDescriptor ?  channelDescriptor.attributes.property || {} : {},
              unreadMessages: 0,
              lastMessageText: "",
              lastMessageDate: null,
              users: {},
              invited: false,
            };
          }
        }

        const channelsData = await Promise.all([
          ...list.items.map(async (curr) => {
            return await getChannelData(curr.sid, curr)
          }),
          ...requiredChannelsIds.map(async (sid) => {
            return await getChannelData(sid, undefined)
          })
        ]);

        const userChannels = channelsData.sort(
          (a, b) => new Date(b.lastMessageDate) - new Date(a.lastMessageDate)
        );

        setChannels({ list: userChannels, filtered: userChannels, search: "" });
        setLoadingState({ initial: false, updating: false });
        setAllChannelsLoaded(true);

        if (onChannelsLoaded) onChannelsLoaded(userChannels);

        setChannelUserStatuses(
          userChannels.reduce((acc, channel) => {
            acc[channel.channelId] = channel.users;
            return acc;
          }, {})
        );
      } catch (error) {
        console.error("Error fetching channels:", error);
        setLoadingState({ initial: false, updating: false });
      }
    },
    [client, user.id, onChannelsLoaded]
  );

  const updateUnreadCount = useCallback((channelId, count) => {
    setChannels((prev) => {
      const updatedList = prev.list.map((channel) =>
        channel.channelId === channelId
          ? { ...channel, unreadMessages: count }
          : channel
      );
      const filteredList = updatedList.filter((channel) => {
        const prop = channel.property || {};
        return (
          prop.name.toUpperCase().includes(prev.search.toUpperCase()) ||
          prop.host.toUpperCase().includes(prev.search.toUpperCase()) ||
          prop.reservationId.toUpperCase().includes(prev.search.toUpperCase())
        );
      });
      return { ...prev, list: updatedList, filtered: filteredList };
    });
  }, []);

  useEffect(() => {
    fetchUserChannels(true);
  }, []);

  useEffect(() => {
    if (!loadingState.initial) {
      fetchUserChannels();
    }
  }, [fetchUserChannels, refreshChatlist, loadingState.initial, channelsForForceUpdate]);

  useEffect(() => {
    setLoadingState((prev) => ({
      ...prev,
      updating: receivingMessages.size > 0,
    }));
  }, [receivingMessages]);

  function handleSearchFilter(text) {
    setChannels((prev) => {
      const filtered = prev.list.filter((channel) => {
        const property = channel.property || {};
        const combined =
          (property.name || "") +
          "-" +
          (property.user || "") +
          "-" +
          (property.host || "") +
          "-" +
          (property.reservationId || "");
        return combined.toUpperCase().includes(text.toUpperCase());
      });
      return { ...prev, search: text, filtered };
    });
  }

  return (
    <div
      className={`tw-flex tw-flex-col md:tw-col-span-2 tw-rounded-md tw-text-sm tw-z-[2]  tw-max-h-full tw-top-0 tw-bottom-0 tw-right-0 tw-left-0 tw-absolute md:tw-static tw-transform md:tw-transform-none tw-transition-all tw-overflow-hidden ${
        viewList ? " tw-translate-x-[-100%]" : " "
      }`}
      style={{ background: "#f5f7fb" }}
    >
      <div className="tw-p-4 tw-flex ">
        <h2 className="tw-text-lg tw-font-medium">Chats</h2>
      </div>
      <div className="tw-flex tw-items-center tw-p-2">
        <input
          type="text"
          placeholder="Search"
          value={channels.search}
          onChange={(e) => handleSearchFilter(e.target.value)}
          className="tw-w-full tw-bg-white tw-p-2 tw-rounded tw-text-sm tw-outline-none"
        />
      </div>
      {loadingState.initial && !allChannelsLoaded ? (
        <div className="tw-flex tw-justify-center tw-items-center tw-h-screen">
          <div className="loader"></div>
        </div>
      ) : (
        <div
          className="tw-overflow-y-scroll tw-scrollbar-hide tw-flex-grow p-2"
          style={{ scrollbarWidth: "none" }}
        >
          {loadingState.updating && !allChannelsLoaded && (
            <div className="dotloader m-2">
              <div className="dotloading"></div>
              <div className="dotloading"></div>
              <div className="dotloading"></div>
            </div>
          )}
          {!channels.list.length && (
            <p style={{ textAlign: "center", margin: "2.5rem 0" }}>
              No Conversation Found!
            </p>
          )}
          {pagination.hasPrevPage && (
            <p
              onClick={() => loadPage("prev")}
              style={{
                margin: "0.5rem 0",
                textAlign: "center",
                fontSize: "0.875rem",
                cursor: "pointer",
              }}
            >
              Prev
            </p>
          )}
          {(channels.search ? channels.filtered : channels.list).map(
            (curr, ind) => (
              <ChatCard
                key={ind}
                data={curr}
                activeChannel={activeChannel}
                onSelectChannel={onSelectChannel}
                setViewList={setViewList}
                updateUnreadCount={updateUnreadCount}
                userStatus={channelUserStatuses}
              />
            )
          )}
          {pagination.hasNextPage && (
            <p
              onClick={() => loadPage("next")}
              style={{
                margin: "0.5rem 0",
                textAlign: "center",
                fontSize: "0.875rem",
                cursor: "pointer",
              }}
            >
              Load More
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default ChatList;
